import { render, staticRenderFns } from "./LotCard.vue?vue&type=template&id=5ceb36c4&"
import script from "./LotCard.vue?vue&type=script&lang=ts&"
export * from "./LotCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports